import { UserEntity } from "../entity/UserEntity";
import { User } from "../gateway/User/User";
import { UserDataAdapter } from "../presentation/adpters/UserDataAdapter";

export class GetUserApiAppSecretUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ accountingId }) {
        if (!accountingId) return "";
        const userLogged = new UserDataAdapter().user();
        const response = await this.UserGateway.getUsersByRolesAndAccountingId({
            accountingId,
            roles: ["API"],
            options: {}
        });
        const user = response?.list?.[0] ? response?.list?.[0] : false;
        if (user) {
            const userEntity = UserEntity.restoreFromCloud(user);
            return userEntity.getFortesAppSecret();
        } else {
            const responseCreatedUser = await this.UserGateway.createApiUser(
                userLogged?.profile?.name,
                accountingId
            );
            return responseCreatedUser?.apiToken?.token
                ? `Bearer ${responseCreatedUser?.apiToken?.token}`
                : "";
        }
    }
}
